import api from "@/lib/api";

const bytes = (s) => { const pad = "=".repeat((4 - (s.length % 4)) % 4); const raw = atob(s.replace(/-/g, "+").replace(/_/g, "/") + pad); return Uint8Array.from(raw, (c) => c.charCodeAt(0)); };
const b64 = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

export const passkeySupported = () => typeof window !== "undefined" && !!window.PublicKeyCredential && !!navigator.credentials;

export async function platformAuthenticatorAvailable() {
  try { return passkeySupported() && (await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()); } catch { return false; }
}

const credToJSON = (c) => c.toJSON ? c.toJSON() : {
  id: c.id, rawId: b64(c.rawId), type: c.type, authenticatorAttachment: c.authenticatorAttachment,
  clientExtensionResults: c.getClientExtensionResults?.() || {},
  response: {
    clientDataJSON: b64(c.response.clientDataJSON),
    ...(c.response.attestationObject ? { attestationObject: b64(c.response.attestationObject), transports: c.response.getTransports?.() || [] } : {}),
    ...(c.response.authenticatorData ? { authenticatorData: b64(c.response.authenticatorData), signature: b64(c.response.signature), userHandle: c.response.userHandle ? b64(c.response.userHandle) : null } : {}),
  },
};

export async function passkeyRegister(label) {
  const { data } = await api.post("/auth/passkey/register/options");
  const o = JSON.parse(data.options);
  o.challenge = bytes(o.challenge); o.user.id = bytes(o.user.id);
  o.excludeCredentials = (o.excludeCredentials || []).map((x) => ({ ...x, id: bytes(x.id) }));
  const cred = await navigator.credentials.create({ publicKey: o });
  await api.post("/auth/passkey/register/finish", { credential: credToJSON(cred), ceremony_token: data.ceremony_token, label });
}

export async function passkeyLogin(email) {
  const { data } = await api.post("/auth/passkey/login/options", { email: email || null });
  const o = JSON.parse(data.options);
  o.challenge = bytes(o.challenge);
  o.allowCredentials = (o.allowCredentials || []).map((x) => ({ ...x, id: bytes(x.id) }));
  const cred = await navigator.credentials.get({ publicKey: o });
  const res = await api.post("/auth/passkey/login/finish", { credential: credToJSON(cred), ceremony_token: data.ceremony_token });
  return res.data;
}
